import { Skeleton } from "@needl-ai/common/components/ui/skeleton";

interface SessionSkeletonProps {
  titleWidth?: string;
  index?: number;
}

const SessionSkeleton = ({
  titleWidth = "w-full",
  index = 0,
}: SessionSkeletonProps) => {
  return (
    <div
      className="flex items-center gap-3 p-2 rounded-lg bg-gray-50/50 dark:bg-neutral-900"
      style={{
        animationDelay: `${index * 100}ms`,
      }}
    >
      {/* Icon skeleton */}
      <div className="flex-shrink-0">
        <Skeleton className="w-4 h-4 rounded-full bg-gray-300 dark:bg-neutral-700" />
      </div>

      {/* Content skeleton */}
      <div className="flex-1 min-w-0 space-y-1.5">
        {/* Title skeleton with varied width */}
        <Skeleton
          className={`h-3.5 ${titleWidth || "w-full"} bg-gray-300 dark:bg-neutral-700`}
        />
        {/* Time skeleton */}
        <Skeleton className="h-3 w-16 bg-gray-300 dark:bg-neutral-700" />
      </div>

      {/* Action button skeleton - hidden to match real items */}
      <div className="flex-shrink-0">
        <Skeleton className="w-5 h-5 rounded opacity-0" />
      </div>
    </div>
  );
};

const SessionListSkeleton = ({ count = 3 }: { count?: number }) => {
  // Create varied widths for more realistic skeleton
  const widths = ["w-3/4", "w-1/2", "w-2/3", "w-4/5", "w-3/5"];

  return (
    <div className="space-y-1 animate-pulse">
      {Array.from({ length: count }).map((_, index) => (
        <SessionSkeleton
          key={index}
          titleWidth={widths[index % widths.length] || "w-full"}
          index={index}
        />
      ))}
    </div>
  );
};

export { SessionListSkeleton, SessionSkeleton };
export default SessionListSkeleton;
